<template>
  <span
    class="tw-leading-none tw-px-1 tw-h-4 tw-min-w-2 tw-box-content tw-text-center tw-text-xs tw-pointer-events-none"
    :class="[
      colorComp,
      borderComp,
      rounded === 'full' ? 'tw-rounded-full' : 'tw-rounded',
    ]"
  >
    <span class="tw-leading-4" :class="{ 'tw-opacity-70': color === 'dark' }">
      {{ text }}
    </span>
  </span>
</template>

<script>
import { useTheming } from '@composables'
import { computed, toRefs } from 'vue'

export default {
  props: {
    text: {
      type: [String, Number],
      default: '',
    },
    color: {
      type: String,
      validator: (val) => ['primary', 'dark', 'danger'].includes(val),
      default: 'primary',
    },
    rounded: {
      type: String,
      validator: (val) => ['full', 'small'].includes(val),
      default: 'full',
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { color, border } = toRefs(props)
    const { lowDangerWCAGContrast } = useTheming()

    const colorComp = computed(() => {
      switch (color.value) {
        default:
          return 'game-primary-button-color game-primary-text'

        case 'dark':
          return 'tw-bg-black/50 tw-text-white'

        case 'danger':
          return lowDangerWCAGContrast.value
            ? 'tw-bg-white tw-text-black'
            : 'tw-bg-danger tw-text-danger-text'
      }
    })

    const borderComp = computed(() => {
      if (border.value) {
        switch (color.value) {
          case 'dark':
            return 'tw-border tw-border-black'

          case 'danger':
            return 'md:tw-border md:tw-border-primary'
        }
      }
      return ''
    })

    return {
      borderComp,
      colorComp,
    }
  },
}
</script>
